export enum InventorizationStatus {
  correct = 1,
  incorrect = 2,
}

export enum InventorizationIncorrectStatus {
  place_empty = 1,
  pallet_missing = 2,
  wrong_pallet = 3,
}
